import { render, staticRenderFns } from "./Shifts.vue?vue&type=template&id=dd9a50aa&scoped=true&"
import script from "./Shifts.vue?vue&type=script&lang=js&"
export * from "./Shifts.vue?vue&type=script&lang=js&"
import style0 from "./Shifts.vue?vue&type=style&index=0&id=dd9a50aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9a50aa",
  null
  
)

export default component.exports